/**
 * @Description 筛选列表
 */
import { FC } from 'react';
import styles from '../index.module.less';
import { Badge } from 'antd';
import IconFont from '@/common/components/IconFont';
import { leftListSelectionDOM } from '../../../../ts-config';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';

const SelectionList:FC<{
  setActive,
  selectionListRef,
  setFirstActive,
  firstMenuItem,
  curLeftSection
}> = ({
  setActive,
  selectionListRef,
  setFirstActive,
  firstMenuItem,
  curLeftSection
}) => {

  const methods = useMethods({
    // 一级菜单悬浮事件
    onFirstMenuMouseEnter(item) {
      if (item.children?.length) {
        setActive('');
      } else {
        setActive(item.code);
      }
      setFirstActive(item.code);
    },
  });


  return <div
    className={cs(styles.selectionListCon, styles.left)}
  >
    <div className={styles.top}>
      <img src='https://staticres.linhuiba.com/project-custom/locationpc/lcn/filter-points.png' alt='' style={{ height: 18 }} className={styles.textImg}/>
      <img src='https://staticres.linhuiba.com/project-custom/locationpc/map/icon_siteselectionmap_arrow.png' alt='' className={styles.arrowImg}/>
    </div>
    <div
      className={cs(leftListSelectionDOM, styles.list)}
      ref={selectionListRef}
    >
      {
        curLeftSection?.map((item) => {
          return <div
            className={cs(
              styles.card,
              (item.code === firstMenuItem.code) ? styles.activeCard : ''
            )}
            onMouseEnter={() => methods.onFirstMenuMouseEnter(item)}
            // onMouseLeave={() => setActive('')}
            key={item.code}>
            <Badge
              count={item.count}
              size='small'
              overflowCount={10}
            >
              <span className={styles.label}>{item.label}</span>
            </Badge>
            <IconFont iconHref='iconic_next_black_seven' className={styles.icon}/>
          </div>;
        }
        )}
    </div>
  </div>;
};
export default SelectionList;
